import { hinge } from 'src/features/gorilla/drawer/catchermitt/rightThrow/front/lace/hinge'
import { inMachiOfCommon, inMachiOfNormalPocket } from 'src/features/gorilla/drawer/catchermitt/rightThrow/front/lace/inMachi'
import {
  arroundEdge0,
  arroundEdge1,
  arroundEdge10,
  arroundEdge11,
  arroundEdge2,
  arroundEdge3,
  arroundEdge4,
  arroundEdge5,
  arroundEdge6,
  arroundEdge7,
  arroundEdge8,
  arroundEdge9
} from './arroundEdge'
import { webTop1, webTop2, webTop3 } from './web'
import { connectCatchFace } from './connectCatchFace'
import { State } from 'src/types'

export const laceDrawer = (ctx: CanvasRenderingContext2D, state: State): void => {
  const color = state.lace.color

  arroundEdge0(ctx, color)
  arroundEdge1(ctx, color, 2, 0)
  arroundEdge1(ctx, color, 19, 32)
  arroundEdge2(ctx, color, 15, -65, 7)
  arroundEdge2(ctx, color, 0, 0, 0)
  arroundEdge2(ctx, color, -30, 60, -7)
  arroundEdge2(ctx, color, -96, 123, -17)
  arroundEdge2(ctx, color, -35, 150, -13)
  arroundEdge3(ctx, color, -80, -38)
  arroundEdge3(ctx, color, -40, -15)
  arroundEdge3(ctx, color, 0, 0)
  arroundEdge3(ctx, color, -132, 103, -15)
  arroundEdge3(ctx, color, -92, 119, -15)
  arroundEdge3(ctx, color, -387, 200, -40)
  arroundEdge4(ctx, color, -27, 19)
  arroundEdge4(ctx, color, 0, 0)
  arroundEdge4(ctx, color, 32, -25)
  arroundEdge4(ctx, color, 60, -51)
  arroundEdge5(ctx, color, 14, -42)
  arroundEdge5(ctx, color, 1, 0)
  arroundEdge5(ctx, color, -23, 40)
  arroundEdge6(ctx, color, -46, 192, -15, 0.9)
  arroundEdge6(ctx, color, 0, 0)
  arroundEdge7(ctx, color, 49, -83, 10)
  arroundEdge7(ctx, color, 0, 0)
  arroundEdge7(ctx, color, -34, 13, -5)
  arroundEdge7(ctx, color, -102, 78, -15)
  arroundEdge7(ctx, color, -183, 133, -25)
  arroundEdge8(ctx, color, 52, -148, 15)
  arroundEdge8(ctx, color, 0, 0)
  arroundEdge8(ctx, color, -43, -10)
  arroundEdge8(ctx, color, -85, -14)
  arroundEdge9(ctx, color, 38, -3)
  arroundEdge9(ctx, color, 0, 0)
  arroundEdge9(ctx, color, -36, 5)
  arroundEdge9(ctx, color, -90, 77, -10)
  arroundEdge10(ctx, color, 7, -213, 30)
  arroundEdge10(ctx, color, 0, 0)
  webTop3(ctx, color)
  webTop1(ctx, color, 180, -260, 20)
  webTop2(ctx, color, 138, -178, 13)
  webTop2(ctx, color, 122, -158, 13)
  webTop2(ctx, color, 106, -138, 13)
  webTop2(ctx, color, 88, -108, 10)
  webTop2(ctx, color, 60, -70, 5)
  webTop2(ctx, color, 30, -37)
  webTop2(ctx, color, 12, -17)
  webTop2(ctx, color, 0, 0)
  webTop2(ctx, color, -14, 18)
  webTop1(ctx, color, 0, 0)

  connectCatchFace(ctx, color)
  hinge(ctx, color, -30, 30) // 左
  hinge(ctx, color, 0, 0) // 中央
  hinge(ctx, color, 33, -30) // 右
  inMachiOfCommon(ctx, color)
  inMachiOfNormalPocket(ctx, color)
  arroundEdge11(ctx, color)
}
